<template>
    <div>
        <el-form ref="form" :model="form" label-width="100px" :rules="$rules.AddSystem">
            <el-row >
                <el-col  >
                     <el-form-item label="中文名：" prop="name">
                        <el-input  v-model="form.name" placeholder="请输入中文名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="服务名：" prop="serviceName">
                        <el-input  v-model="form.serviceName" placeholder="请输入服务名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="系统描述："  prop="description">
                        <el-input type="textarea" :autosize="{ minRows: 3}" v-model="form.description" placeholder="请输入系统描述"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="buttons">
                    <el-button @click="$emit('update:visibles',false)">取消</el-button>
                    <el-button type="primary" @click="submit()">提交</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    type: {
      type: String
    },
    row: {
      type: Object
    }
  },
  data () {
    return {
      form: {
      },
      loading: false,
      departmentList: [],
      deptIds: null
    }
  },
  methods: {
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1

      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    // 提交
    submit () {
      var that = this
      that.$refs.form.validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-vars
          var Submitform = {}
          if (that.type === 'add') {
            Submitform = this.form
          } else if (this.type === 'edit') {
            Submitform = {
              id: that.form.id,
              name: that.form.name,
              description: that.form.description,
              serviceName: that.form.serviceName
            }
          } else if (this.type === 'AddMenu') {
            Submitform = {
              parentId: that.row.id,
              name: that.form.name,
              link: that.form.link,
              description: that.form.description
            }
          }
          var RequestType = that.type === 'add' ? 'put' : 'put'
          var RequestTypeText = that.type === 'add' ? '添加' : '修改'
          var RequestUrl = that.type === 'add' ? '"/ucenter/sys-model/saveOrUpdateSysModel"' : '"/ucenter/sys-model/saveOrUpdateSysModel"'
          // eslint-disable-next-line
          eval(
                `that.$http.${RequestType}(${RequestUrl},${JSON.stringify(Submitform)}).then((res) => {
                    if(res.status == 200){
                        that.$message.success('${RequestTypeText}成功')
                        that.$emit('update:visibles',false)
                        that.$emit('Render')
                        sessionStorage.removeItem('dict.department.list')
                    } else {
                        that.$message.error('${RequestTypeText}失败')
                        that.$emit('update:visibles',true)
                    }
                })`
          )
        }
      })
    },
    // js暂停的方法
    sleep (interval) {
      return new Promise(resolve => {
        this.loading = true
        setTimeout(resolve, interval)
      })
    },
    async Layoutfun (query = '', data, Parameter1) {
      if (query !== '') {
        await this.sleep(150)
        this.loading = false
        // eslint-disable-next-line no-eval
        return data.filter(item => { return eval('item.' + Parameter1).toLowerCase().indexOf(query.toLowerCase()) > -1 })
      } else {
        return data.slice(0, 10)
      }
    },
    // 所属部门
    departmentRemoteMethod (query) {
      this.Layoutfun(query, this.$department.list(), 'name').then(res => {
        this.departmentList = res
        this.addValueOptions()
      })
    },
    // 修改回显问题
    addValueOptions () {
      if (this.deptIds) {
        const target = this.$department.list().find((item) => { // 从大option中找到当前条
          return item.id === this.deptIds
        })
        if (target) { // 将当前条与小option比对，没有则加入
          if (this.departmentList.every(item => item.id !== target.id)) {
            this.departmentList.unshift(target)
          }
        }
      }
    }
  },
  created () {
    if (this.type === 'edit') {
      this.form = JSON.parse(JSON.stringify(this.row))
      this.deptIds = this.form.deptId
    }
    this.departmentRemoteMethod()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.buttons{
    text-align: center;
}
</style>
